import { useRouter } from 'next/router';
import { useMount } from 'react-use';
import authApi from '~/authApi';
import { AppLoader } from '~/components/AppLoader';
import withAuthRequired from '~/components/withAuthRequired';
import { FEATURE_FLAGS, USER_ROLES } from '~/constants';
import { useAuth } from '~/contexts/auth';
import { useFeature } from '~/hooks/useFeatureFlag/useFeature';

const Index = () => {
  const router = useRouter();
  const { getMainUrl } = useAuth();
  const { isEnabled: isMediaKitsForCreatorsEnabled, status } = useFeature(
    FEATURE_FLAGS.foamCreatorMediaKits,
  );

  const userIsCreator = authApi.user.roles.includes(USER_ROLES.creator);

  // https://github.com/vercel/next.js/issues/6713
  useMount(() => {
    if (status === 'loading') return;

    const mainUrl = getMainUrl();

    if (
      userIsCreator &&
      isMediaKitsForCreatorsEnabled &&
      mainUrl !== '/reconnect-platforms'
    ) {
      router.push('/media-kits');
      return;
    }
    router.push(mainUrl);
  });

  return <AppLoader />;
};

export default withAuthRequired(Index);
